import styled from "styled-components";
import { bodyTextBold, bodyTextRegular, headingText } from "../layout/style";

const VisExplanationContainer = styled.div`
    position: absolute;
    z-index: 1000;
    width: 20%;
    top: 0px;
    right: 0px;
    height: 100%;
    border-left: 1px solid #ffffff;
    background-color: rgba(0,0,0,0.7);
    padding: 0px 10px 100px 10px;

    color: #ffffff;

    ${bodyTextRegular}
`;

const StudyHeader = styled.h2`
    ${bodyTextBold}
    color: #ffffff;
    font-size: 1.6rem;
    text-align: center;
`;

const VisDemoExplanation = () => {



    return <VisExplanationContainer>
        <h2>Demonstration</h2>
        <p>This demonstration illustrates the current iteration of the visualization, using simulated data from the wearable sensors. As the dancers move through each study in the duet, pressure data are collected in real time from their interaction. These data are used to control different visual attributes of a system of particles, including visibility, size, and movement in two dimensions.</p>
        <p>As the demonstration cycles through the studies, pay close attention: What do you notice? What subtle changes are occurring in the appearance of the particles? How do different dimensions of embodiment get revealed bit by bit for the particles? What forms emerge from the ensemble of particles moving in relation to one another?</p>
        <p>In each performance, the data collected by the sensors are different. Thus, each visualization becomes a new painting of data, reflecting the new cycle of movement negotiated between the dancers.</p>
    </VisExplanationContainer>
}

export default VisDemoExplanation;